import React from 'react';
interface SectionHeadingProps {
  id?: string;
  eyebrow?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  align?: 'center' | 'left';
  tone?: 'ink' | 'cream';
  level?: 2 | 3;
}
export function SectionHeading({
  id,
  eyebrow,
  title,
  intro,
  align = 'center',
  tone = 'ink',
  level = 2
}: SectionHeadingProps) {
  const Tag = level === 2 ? 'h2' : 'h3';
  const alignment = align === 'center' ? 'items-center text-center mx-auto' : 'items-start text-left';
  const titleColor = tone === 'ink' ? 'text-stone-900' : 'text-stone-50';
  const introColor = tone === 'ink' ? 'text-stone-600' : 'text-stone-50/70';
  return <div className={`flex max-w-3xl flex-col gap-5 ${alignment}`} data-id="element-168" data-mp="1u0v7ly7xlaj">
      {eyebrow ? <span className="text-xs font-semibold uppercase tracking-[0.22em] text-brand" data-id="element-169" data-mp="6slo10b552oy">{eyebrow}</span> : null}
      <Tag id={id} className={`font-serif text-3xl leading-[1.08] sm:text-4xl lg:text-[2.9rem] ${titleColor}`} data-id="element-170" data-mp="uifzpejq4l7m">
        {title}
      </Tag>
      {intro ? <p className={`text-lg leading-relaxed ${introColor}`} data-id="element-171" data-mp="1t9yzpvl6agk2">{intro}</p> : null}
    </div>;
}